import { defineChapter } from '../../define';
import bindBug from './challenges/bind-bug/meta';
import boss from './challenges/boss/meta';
import classCounter from './challenges/class-counter/meta';
import getters from './challenges/getters/meta';
import thisPredict from './challenges/this-predict/meta';

export default defineChapter({
  id: 'js-objects',
  slug: 'objects',
  title: 'Objects and this',
  position: 4,
  challenges: [thisPredict, bindBug, classCounter, getters, boss],
});
